import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { LoginForm, ProFormText } from '@ant-design/pro-components';
import '@/styles/pages/login.scss';
import { useEffect, useState } from 'react';
import ajax from '@/scripts/ajax';
import JSEncrypt from 'jsencrypt';
import { getPath } from '@/scripts/utils';
import Cookies from 'js-cookie';
import { COOKIE_TOKEN } from '@/scripts/config';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { apiSlice } from '@/store/apiSlice';
import { PATH_ORDER_LIST } from '@/router/path';
import { Log } from '@icon-park/react';
import { message } from 'antd';

export default function Login() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // state
    const [verifyImage, setVerifyImage] = useState(null);
    const [verifyKey, setVerifyKey] = useState();
    const [rsaKey, setRsaKey] = useState();
    const [rsaPublic, setRsaPublic] = useState();

    useEffect(() => {
        if (Cookies.get(COOKIE_TOKEN)) goHome();
    }, []);

    // 前往管理后台主页
    const goHome = () => {
        // 清除所有redux缓存
        dispatch(apiSlice.util.resetApiState());
        navigate(getPath([PATH_ORDER_LIST]));
    };

    // 处理登录回调
    const handleLoginSubmit = async (formValue) => {
        // params.password = formValue.password;
        // 使用公钥加密
        // const encryptor = new JSEncrypt();
        // encryptor.setPublicKey(rsaPublic);
        // const encodePsw = encryptor.encrypt(formValue.password);
        // const params = { ...formValue, Key: verifyKey, rsaKey, client: 'Web' };
        const params = { ...formValue, Key: verifyKey, rsaKey };

        let res = await ajax.post('/admin/login', params);

        // 写入Cookie
        if (res && res.access_token) {
            Cookies.set(COOKIE_TOKEN, res.access_token, { expires: 7 });
            if (res.refresh_token) {
                localStorage.setItem('refresh_token', res.refresh_token);
            }
            setTimeout(() => {
                goHome();
            }, 1000);
        }
    };

    return (
        <div className="login">
            <div className="login__main">
                <LoginForm title="Spacem" subTitle="quick start" onFinish={handleLoginSubmit}>
                    <ProFormText
                        name="username"
                        fieldProps={{
                            size: 'large',
                            prefix: <UserOutlined className="prefixIcon" />,
                        }}
                        placeholder="用户名"
                        rules={[
                            {
                                required: true,
                                message: '请输入用户名!',
                            },
                        ]}
                    />
                    <ProFormText.Password
                        name="password"
                        fieldProps={{
                            size: 'large',
                            prefix: <LockOutlined className="prefixIcon" />,
                        }}
                        placeholder="密码"
                        rules={[
                            {
                                required: true,
                                message: '请输入密码！',
                            },
                        ]}
                    />
                    {/*<ProFormText*/}
                    {/*    name="verifyCode"*/}
                    {/*    fieldProps={{*/}
                    {/*        size: 'large',*/}
                    {/*        suffix: verifyImage ? <img src={verifyImage} alt="验证码" /> : null,*/}
                    {/*    }}*/}
                    {/*    placeholder="验证码"*/}
                    {/*    rules={[*/}
                    {/*        {*/}
                    {/*            required: true,*/}
                    {/*            message: '请输入验证码!',*/}
                    {/*        },*/}
                    {/*    ]}*/}
                    {/*/>*/}
                </LoginForm>
            </div>
        </div>
    );
}
